import { render, staticRenderFns } from "./Widget5.vue?vue&type=template&id=d6842238&"
import script from "./Widget5.vue?vue&type=script&lang=js&"
export * from "./Widget5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports